import axios from 'axios';
import store from '../store'

const PREFIJO = "/api/Ntsrd/";

export default {
    generarLeadInteresado(formulario, details, tipoInteresado) {
        const token = JSON.parse(localStorage.getItem('token'));
        const fecha = JSON.parse(localStorage.getItem('fecha'));
        const dto = {
            dt1: (formulario.firstName1 || "") + " " + (formulario.firstName2 || ""), //nombres
            dt3: (formulario.lastName1 || "") + " " + (formulario.lastName2 || ""), //apellidos
            dt5: formulario.phoneNumber,  //celular
            dt6: formulario.email,      //email
            dt10: formulario.documentNumber,  //numero documento
            dt12: process.env.VUE_APP_FUENTE,  //fuente WEB
            dt13: process.env.VUE_APP_TIPO_PRODUCTO,  // tipo producto VEHICILO LIVIANO
            dt14: process.env.VUE_APP_LINEA_NEGOCIO,   //linea negocio NUEVO
            dt15: formulario.nameDocumentType,         // nombre tipo documento
            dt16: process.env.VUE_APP_PAIS_NAME,        // Pais
            dt20: token,
            dt35: formulario.razonSocial,     // razon social en caso de ser jurido
            dt17: formulario.nameTypePerson,   // tipo persona
            dt18: process.env.VUE_APP_RED_COMERCIAL, // red comercial
            ndt2: tipoInteresado.id,
            ndt6: process.env.VUE_APP_AGENCIA_LEAD,
            ndt10: details.ndt3,
            ndt11: details.id,
            ddt4: fecha,
            bdt1: formulario.dataConsent
        }
        return axios.post(`${PREFIJO}VmCrNtr`, dto)
    },
}

